import React, { useEffect, useState } from "react";
// import "./UserManagement.scss";
import { loginScreen, userPlaceholderIcon } from "assets/images";
import { Link, useParams } from "react-router-dom";
import { toastMessage } from "utils/toastMessage";
import useFullPageLoader from "common/UseFullPageLoader";

import { dateFormat } from "utils/dateFormat";
import { CustomModal } from "components/modals/ModalBox";
import { AiOutlineDownload } from "react-icons/ai";
import usePlaceholder from "react-bootstrap/esm/usePlaceholder";
import { userPlaceholder } from "assets/icons";
import { postDetailApi } from "services/post";
import { IoMdArrowRoundBack } from "react-icons/io";
import { orderDetailApi } from "services/order";
import NotFound from "common/NotFound";
import { searchDateFormat } from "common/InputForm";

const OrderDetail = () => {
  const [loader, onShow, onHide] = useFullPageLoader();
  const { id } = useParams();
  const [formData, setFormData] = useState({});
  const [videoData, setVideoData] = useState("");

  const [imagePreview, setImagePreview] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  useEffect(() => {
    fetchOrderDetails(id);
  }, [id]);

  const fetchOrderDetails = async () => {
    try {
      const res = await orderDetailApi(id);
      if (res?.data?.status === 200) {
        setFormData({
          orderId: id,
          orderNumber: res.data.data.order.orderNumber,
          userName: res.data.data.order.userName,
          products: res.data.data.order.products,
          userEmail: res.data.data.order.userEmail,
          userMobile: res.data.data.order.userMobile,
          createdAt: res.data.data.order.createdAt,
          confirmedAt: res.data.data.order.confirmedAt,
          enrouteAt: res.data.data.order.enrouteAt,
          reachedAt: res.data.data.order.reachedAt,
          deliveredAt: res.data.data.order.deliveredAt,
          cancelledAt: res.data.data.order.cancelledAt,
          refundAt: res.data.data.order.refundAt,
          refundAmount: res.data.data.order.refundAmount,
          refundId: res.data.data.order.refundId,
          cancelReason: res.data.data.order.cancelReason,
          cancellationMethod: res.data.data.order.cancellationMethod,
          refundStatus: res.data.data.order.refundStatus,
          itemAmount: res.data.data.order.itemAmount,
          taxAmount: res.data.data.order.taxAmount,
          deliveryCharge: res.data.data.order.deliveryCharge,
          totalAmount: res.data.data.order.totalAmount,
          status: res.data.data.order.status,
          deliveryAddress: res.data.data.order.deliveryAddress,
        });
        setVideoData(res.data.data.post?.video?.url);
      } else {
        toastMessage(res?.data?.message, "error", "postDetail");
      }
    } catch (e) {
      toastMessage(e.message, "error", "postDetail");
    }
  };
  return (
    <>
      {loader}
      <div className="editProfile user_management">
        <div className="dashboard_title">
          <h3>
            <Link to={"/order-management"}>
              <IoMdArrowRoundBack />
            </Link>{" "}
            Order details
          </h3>
        </div>
        <div className="card">
          <div className="card-body">
            <div className="personal_details _box spacing">
              <div className="details_list">
                <ul>
                  <li>
                    <b>Oder Number : </b>
                    <span> {formData.orderNumber}</span>
                  </li>

                  <li>
                    <b>User name : </b>
                    <span> {formData?.userName}</span>
                  </li>
                  <li>
                    <b>Email: </b>
                    <span> {formData.userEmail}</span>
                  </li>
                  <li>
                    <b>Mobile:</b>
                    <span> {formData?.userMobile}</span>
                  </li>
                  <li>
                    <b>Order status:</b>
                    <span> {formData?.status}</span>
                  </li>
                  <li>
                    <b>Total Amount:</b>
                    <span>₹ {formData?.totalAmount}</span>
                  </li>
                  <li>
                    <b>Created At:</b>
                    <span> {searchDateFormat(formData?.createdAt)}</span>
                  </li>
                  <li>
                    <b>Delivery Address:</b>
                    <span>
                      {formData.deliveryAddress
                        ? `${formData.deliveryAddress.address}, ${formData.deliveryAddress.city}, ${formData.deliveryAddress.state} - ${formData.deliveryAddress.pincode}`
                        : "N/A"}
                    </span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="card">
              <div className="card-body">
                <div className="table_wrap ">
                  <table className="table custom_table">
                    <thead>
                      <tr>
                        <th>Sr.</th>
                        <th>Image</th>
                        <th>Product Title</th>
                        <th>Qty</th>
                        <th>Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {formData.products && formData.products?.length > 0 ? (
                        formData.products?.map((data, index) => {
                          console.log(data, "datvva");
                          return (
                            <tr key={++index}>
                              <td>{index + 1}</td>
                              <td className="nowrap">
                                {" "}
                                <button
                                  type="button"
                                  onClick={() => {
                                    setImagePreview(true);
                                    setImageUrl(data.image);
                                  }}
                                >
                                  <img
                                    src={
                                      data.image ? data.image : userPlaceholder
                                    }
                                    className="poster"
                                    alt=""
                                  />
                                </button>
                              </td>
                              <td>{data?.name}</td>
                              <td>{data?.quantity}</td>
                              <td>{data?.price}</td>
                            </tr>
                          );
                        })
                      ) : (
                        <NotFound
                          cols={7}
                          msg={"Product data not found"}
                          onHide={onHide}
                        />
                      )}
                    </tbody>
                  </table>
                </div>
                <div className="billing_summery">
                  <ul>
                    <li>
                      <b>Total Amount</b>
                      <span>₹ {formData.itemAmount}</span>
                    </li>

                    {/* <li>
                      <b>Tax Amount</b>
                      <span>₹ {formData.taxAmount}</span>
                    </li>
                    <li>
                        <b>Discount Price </b>
                        <span>
                          ₹
                          {formData?.coupon?.discount}
                        </span>
                      </li>
                    <li>
                      <b>Delivery Charge </b>
                      <span>₹ {formData.deliveryCharge}</span>
                    </li>
                    <li>
                      <b>Grand Amount</b>
                      <span className="bold_span_b">
                        {" "}
                        ₹ {formData.totalAmount}
                      </span>
                    </li> */}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <CustomModal
        show={imagePreview}
        handleClose={() => setImagePreview(false)}
        className={"image_preview_modal"}
      >
        <img src={imageUrl ? imageUrl : loginScreen} alt="" />
      </CustomModal>
    </>
  );
};

export default OrderDetail;
